module.exports = __webpack_public_path__ + "img/Dantam Makeover 27.bf4eaa94.jpg";